"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomCharacterPlacementMessage = void 0;
var common_1 = require("@timeflies/common");
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.RoomCharacterPlacementMessage = message_1.createMessage('room/character/placement', joi_1.default.object({
    characterId: common_1.characterIdSchema,
    position: common_1.positionSchema.allow(null)
}))
    .withResponse();
